import { useEffect, useState } from "react";
import EditableText, {
	EditableVariant,
} from "src/components/form/EditableText";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";

interface TaskEditableTitleProps extends Translation {
	className?: string;
	variant: EditableVariant;
	autoFocus?: boolean;
}

const TaskEditableTitle = ({
	t,
	className,
	variant,
	autoFocus,
}: TaskEditableTitleProps) => {
	const { task, actions } = useTaskForm();
	const [title, setTitle] = useState<string>();

	useEffect(() => {
		setTitle(task.title);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [task]);

	return (
		<EditableText
			{...{ className, variant, autoFocus }}
			// value={task.title}
			value={title}
			onChange={(e: any) => {
				let title = e.target.value;
				title = title.charAt(0).toUpperCase() + title.slice(1);
				// actions.set({ title });
				setTitle(title);
			}}
			placeholder={t("placeholder")}
			onBlur={() => {
				if (title && !task.id) {
					actions.create("INTERNAL", {
						disableRedirect: true,
						updateState: true,
						data: {
							title,
						},
					});
				} else if (task.title !== title) {
					actions.set({
						title,
					});
					// actions.save({
					// 	disableAlert: true,
					// });
				}
			}}
		/>
	);
};

TaskEditableTitle.locale = {
	nl: {
		placeholder: "Titel...",
	},
	en: {
		placeholder: "Title...",
	},
};

export default withTranslation(TaskEditableTitle);
